module.exports = __webpack_public_path__ + "static/media/icon-no-results.a4b8fa7d.svg";